import { getCategoryColor } from "./categoryColorMapping";

export const getPieChartOptions = (labels, isCompany = false, otherSliceDetails = null, seriesData = []) => {
  const mappedColors = labels && labels.length > 0 ? labels.map(label => getCategoryColor(String(label))) : [];

  return {
    chart: {
      toolbar: {
        show: false,
      },
      background: "transparent",
      fontFamily: "Sora, sans-serif",
    },
    labels: labels || [],
    colors: mappedColors,
    title: {
      text: "",
      style: {
        fontSize: "14px",
        fontWeight: "medium",
        fontFamily: "Sora, sans-serif",
        color: "#ffffff",
      },
    },
    tooltip: {
      enabled: true,
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        const color = w.globals.colors[seriesIndex];
        const currentLabel = w.globals.labels[seriesIndex];
        const displayValue = series[seriesIndex]; // Use the value directly from the series for the main display
        let breakdownHtml = "";

        // Check if this is the "Other" slice and if details are available
        if (currentLabel && currentLabel.toLowerCase() === "other" && otherSliceDetails && otherSliceDetails.has(seriesIndex)) {
          const details = otherSliceDetails.get(seriesIndex);
          if (details && details.length > 0) {
            // The displayValue is already the correct sum from the series.
            // We just build the breakdown list.
            breakdownHtml += "<div style='margin-top: 5px; border-top: 1px solid #444; padding-top: 5px;'>";
            breakdownHtml += "<strong style='font-size: 12px; display: block; margin-bottom: 3px;'>Breakdown:</strong>";
            details.forEach(item => {
              breakdownHtml += "<div style='font-size: 11px; margin-left: 10px;'>" + item.label + ": " + item.value.toFixed(1) + "%" + "</div>";
            });
            breakdownHtml += "</div>";
          }
        }

        let tooltipHtml = "<div style='padding: 12px; font-size: 13px; line-height: 1.4; max-width: 300px; word-wrap: break-word;'>";
        tooltipHtml += "<div style='display: flex; align-items: center; margin-bottom: 4px;'>";
        tooltipHtml += "<span style='display: inline-block; width: 12px; height: 12px; border-radius: 50%; background-color: " + color + "; margin-right: 8px;'></span>";
        tooltipHtml += "<strong>" + currentLabel + "</strong>";
        tooltipHtml += "</div>";
        tooltipHtml += "<div style='margin-left: 20px; font-size: 14px; margin-bottom: 5px;'>" + displayValue.toFixed(1) + "%" + "</div>";
        tooltipHtml += breakdownHtml; // Add the breakdown HTML if any
        tooltipHtml += "</div>";
        return tooltipHtml;
      },
      // hideEmptySeries: true, // hide series which have zero values or null data
      fillSeriesColor: false,
      theme: "dark",
      style: {
        fontSize: "14px",
        fontFamily: "Sora, sans-serif",
      },
    },
    stroke: {
      width: 0.2,
      colors: ["rgba(22, 23, 45, 0.8)"],
    },
    legend: {
      show: true,
      position: "right",
      horizontalAlign: "center",
      fontSize: "11px",
      fontFamily: "Sora, sans-serif",
      fontWeight: "medium",
      labels: {
        colors: "#ffffff",
        useSeriesColors: false,
      },
      markers: {
        width: 12,
        height: 12,
        radius: 6,
        strokeWidth: .5,
        strokeColor: '#fff',
        offsetX: -3,
        offsetY: 0
      },
      itemMargin: {
        horizontal: 12,
        vertical: 8
      },
      formatter: function(seriesName, opts) {
        return seriesName.length > 20 ? seriesName.substring(0, 18) + '...' : seriesName;
      }
    },
    dataLabels: {
      enabled: true,  // To determine whether to show dataLabels or not
      textAnchor: "middle",  // The alignment of text relative to dataLabel's drawing position start || middle || end
      style: {
        fontSize: "12px",
        fontFamily: "Sora, sans-serif",
        fontWeight: "medium",
        colors: ["#ffffff"],
      },
      formatter: function(val) {
        return val > 3 ? val.toFixed(0) + "%" : "";
      },
      dropShadow: {
        enabled: true,
        top: 1,
        left: 1,
        blur: 3,
        color: 'rgba(0, 0, 0, 0.5)',
        opacity: 0.8
      },
    },
    plotOptions: {
      pie: {
        customScale: 1,  // Control the size of the pie/donut chart
        expandOnClick: true,
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.35,
        gradientToColors: undefined,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.8,
        stops: [0, 75, 100],
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
      active: {
        filter: {
          type: 'darken',
          value: 0.5,
        }
      }
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 290,
          },
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            itemMargin: {
              horizontal: 8,
              vertical: 5
            },
          },
          plotOptions: {
            pie: {
              customScale: 0.85,
            }
          }
        },
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 290,
          },
          legend: {
            fontSize: "10px",
          },
          plotOptions: {
            pie: {
              customScale: 0.75,
            }
          }
        },
      },
    ],
  };
};